<ng-container *ngIf="expiryDays > 0">
  Expires in {{ expiryDays }} days
</ng-container>

<ng-container *ngIf="expiryDays < 0">
  Expired {{dateExpiry | date: 'MM/dd/yyyy'}}
</ng-container>
